import { MerkleJson } from 'merkle-json';

const signature = json => {
  const mj = new MerkleJson();
  const hash = mj.hash(json);
  return hash;
};

export default signature;
